const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const { Base64 } = require('js-base64');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    'Content-Type': 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    setUserPreferredLanguage(inputparams, metaData) {
      const url = getUrl('setUserPreferredLanguage');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };
      const body = {
        branchCode: parsedMetaData.portfolio.branchCode,
        userId: parsedMetaData.qs.userId,
        lang: inputparams
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },
    getPfMapData(metaData){
    const url = getUrl('userDetails/get-pf-relid-map');
    const parsedMetaData = parseRequestMetaData(metaData);
    const reqOpts = {
      headers: merge(headers, parsedMetaData.headers),
      method: 'POST'
    };
    const body = {
      userId: parsedMetaData.qs.userId,
      channel: parsedMetaData.channel
    };
    return requestHandler(merge(reqOpts, {
      url,
      body,
      json: true,
    }));
      
    },
    get(metaData) {
      const url = getUrl('userDetails/get');
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        langCode: parsedMetaData.portfolio.language
      };

      return requestHandler(merge(
        {},
        reqOpts, { url, body },
        parsedMetaData
      ));
    },
    save(metaData, preferredLang) {
      const url = getUrl('userDetailsPref/save');
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        preferredLang: preferredLang
      };

      return requestHandler(merge(
        {},
        reqOpts, { url, body },
        parsedMetaData
      ));
    },
    updateDeviceDetails(deviceCode, deviceModel, deviceOs, metaData) {
      const url = getUrl('updateDeviceDetails');
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        deviceModel: deviceModel,
        deviceOs: deviceOs,
        deviceCode: deviceCode
      };
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },
    saveFileDownloadConsent(inputParam, metaData) {
      const url = getUrl('saveFileDownloadConsent');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split('#@#');
      const userId = Base64.decode(params[0]);
      const channel = params[1];
      const documentId = Base64.decode(params[2]);
      const documentName = Base64.decode(params[3]);
      const fileType = Base64.decode(params[4]);
      const language = params[5];
      
      const body = {
        userId: userId,
        documentId: documentId,
        documentName: documentName,
        fileType: fileType,//'PDF'
        channel: channel,
        language:language,
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },
  };
}

module.exports = apiFactory;